import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MailCheck, RefreshCw, LogOut, Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FONT = { fontFamily: 'IBM Plex Sans, sans-serif' };

const VerificationRequired = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false); const [note, setNote] = useState('');

  const resend = async () => {
    setBusy(true); setNote('');
    try {
      const { data } = await axios.post(`${API}/auth/verify-email/resend`, {}, { withCredentials: true });
      if (data.cooldown) setNote('A verification e-mail was sent less than a minute ago. Please wait before requesting another.');
      else if (data.sent === false) setNote('We could not deliver the e-mail right now. Please try again in a few minutes or contact support.');
      else setNote(`Verification e-mail sent to ${user?.email}. Check your inbox and spam folder.`);
    } catch (e) {
      setNote(e.response?.status === 429 ? 'Too many requests — please wait a while before trying again.' : 'Could not send the e-mail. Please try again later.');
    } finally { setBusy(false); }
  };

  const signOut = async () => { await logout(); navigate('/login', { replace: true }); };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" style={FONT} data-testid="verification-required-page">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8 space-y-5">
        <div className="w-12 h-12 rounded-full bg-[#002FA7]/10 flex items-center justify-center"><MailCheck className="w-6 h-6 text-[#002FA7]" /></div>
        <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Work Sans, sans-serif' }}>Verify your e-mail</h1>
        <p className="text-sm text-slate-600">We sent a verification link to <span className="font-semibold text-slate-900" data-testid="verification-email">{user?.email}</span>. Click it to activate your company account. The link expires in 24 hours.</p>
        <p className="text-xs text-slate-500">Until then, loads, drivers, payroll, billing and company settings stay locked.</p>
        {note && <div className="p-3 rounded-md bg-slate-50 border border-slate-200 text-sm text-slate-700" data-testid="verification-note">{note}</div>}
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={resend} disabled={busy} className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#002FA7] text-white text-sm font-semibold disabled:opacity-60" data-testid="resend-verification-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />} Resend verification e-mail</button>
          <button type="button" onClick={signOut} className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-slate-300 text-sm font-semibold text-slate-700" data-testid="verification-logout-btn"><LogOut className="w-4 h-4" /> Log out</button>
        </div>
      </div>
    </div>
  );
};

export default VerificationRequired;
